<template>
  <div class="owc-footer-content">
    <ValidationBoxWrapper v-if="isEdit">
      <slot slot="validation-box" name="validation-box" />
    </ValidationBoxWrapper>
    <div class="owc-footer-content__container">
      <div class="wb-grid-row">
        <div v-if="moveToTopVisibility" class="wb-grid-col-mq1-12">
          <SlotContainer
            v-if="isEdit"
            refName="slot-moveToTop"
            slotName="moveToTop"
            class="owc-footer-content__element owc-footer-content__element--center"
          >
            <slot slot="moveToTop" name="moveToTop" />
          </SlotContainer>
          <div
            v-else
            class="owc-footer-content__element
              owc-footer-content__element--center"
          >
            <OwcFooterMoveToTop :moveToTop="moveToTop"></OwcFooterMoveToTop>
          </div>
        </div>

        <div v-if="newsletterVisibility" class="wb-grid-col-mq1-12">
          <SlotContainer v-if="isEdit" refName="slot-newsletter" slotName="newsletter">
            <slot slot="newsletter" name="newsletter" />
          </SlotContainer>
          <div v-else>
            <OwcFooterNewsletter :newsletter="newsletter"></OwcFooterNewsletter>
          </div>
        </div>

        <div v-if="siteMapVisibility" class="wb-grid-col-mq1-12">
          <SlotContainer v-if="isEdit" refName="slot-sitemap" slotName="sitemap">
            <slot slot="sitemap" name="sitemap" />
          </SlotContainer>
          <div v-else>
            <OwcFooterSiteMap :siteMap="siteMap"></OwcFooterSiteMap>
          </div>
        </div>

        <div v-if="contactInfoVisibility" class="wb-grid-col-mq1-12">
          <SlotContainer v-if="isEdit" refName="slot-contactInfo" slotName="contactInfo">
            <slot slot="contactInfo" name="contactInfo" />
          </SlotContainer>
          <div v-else>
            <OwcFooterContactInfo :contactInfo="contactInfo"></OwcFooterContactInfo>
          </div>
        </div>

        <SlotContainer
          v-if="isEdit"
          refName="slot-lowerFooter"
          slotName="lowerFooter"
          class="wb-grid-col-mq1-12"
        >
          <slot slot="lowerFooter" name="lowerFooter" />
        </SlotContainer>
        <div v-else class="wb-grid-col-mq1-12">
          <OwcFooterLowerFooter
            :socialSection="socialSection"
            :legalSection="legalSection"
            :socialSectionVisibility="socialSectionVisibility"
          >
          </OwcFooterLowerFooter>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import {
  FooterComponent,
  FooterComputed,
  FooterData,
  FooterMethods,
  FooterProps,
} from '@owc-packages/Footer/src/Footer';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import OwcFooterMoveToTop from '@owc-packages/Footer/src/MoveToTop.vue';
import OwcFooterNewsletter from '@owc-packages/Footer/src/Newsletter.vue';
import OwcFooterSiteMap from '@owc-packages/Footer/src/SiteMap.vue';
import OwcFooterContactInfo from '@owc-packages/Footer/src/ContactInfo.vue';
import OwcFooterLowerFooter from '@owc-packages/Footer/src/LowerFooter.vue';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import { componentMode } from './Footer.config';
/**
 * `Footer` - Footer for OneWeb - Footer is the last module of the page. It contains links that help the user navigate through the website..
 */

export default (ComponentInitializeDispatcher as FooterComponent).extend<
  FooterData,
  FooterMethods,
  FooterComputed,
  FooterProps
>({
  name: 'owc-footer-content',
  props: {
    componentData: Object,
    isEdit: Boolean,
  },
  components: {
    OwcFooterMoveToTop,
    OwcFooterNewsletter,
    OwcFooterSiteMap,
    OwcFooterContactInfo,
    OwcFooterLowerFooter,
    SlotContainer,
    ValidationBoxWrapper,
  },
  computed: {
    moveToTop() {
      return this.componentData?.moveToTop;
    },
    newsletter() {
      return this.componentData?.newsletter;
    },
    siteMap() {
      return this.componentData?.siteMap;
    },
    contactInfo() {
      return this.componentData?.contactInfo;
    },
    socialSection() {
      return this.componentData?.socialSection;
    },
    legalSection() {
      return this.componentData?.legalSection;
    },
    moveToTopVisibility() {
      return !!this.moveToTop;
    },
    newsletterVisibility() {
      return !!this.newsletter;
    },
    siteMapVisibility() {
      return !!this.siteMap;
    },
    contactInfoVisibility() {
      return !!this.contactInfo;
    },
    socialSectionVisibility() {
      return !!this.socialSection;
    },
  },
  watch: {
    isEdit: {
      handler(newValue: boolean, oldValue: boolean) {
        if (newValue !== oldValue) {
          componentMode.isEditMode = newValue;
        }
      },
      immediate: true,
    },
  },
});
</script>

<style lang="scss">
$footerModuleName: 'owc-footer-content';

.#{$footerModuleName} {
  &__container {
    @include wb-content-width;

    display: flex;
    flex-direction: column;

    margin: 0 auto;

    color: var(--wb-white);

    text-align: left;
  }
  &__element {
    // this is not xs because the 16px carry until desktop
    margin-bottom: 16px;

    &--center {
      text-align: center;
    }
  }
}
</style>
